import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { ensureClinicalCrmTabQuery } from './navigation';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'crm_manage', 'crm_clinical_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/clinical-crm'),
    name: 'clinical_crm_index',
    component: () => import('./Index.vue'),
    meta: commonMeta,
    beforeEnter: ensureClinicalCrmTabQuery,
  },
  {
    path: frontendURL('accounts/:accountId/clinical-crm/settings'),
    name: 'clinical_crm_settings',
    component: () => import('./Settings.vue'),
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator'],
    },
  },
];
